<template>
    <div id="app">
        <transition :name="transitionName">
            <router-view class="transitionName"></router-view>
        </transition>

        <van-tabbar v-model="active" @change="tabbarChange" v-show="showTabbar">
            <van-tabbar-item name="index" replace :to="`/index${dynamicUrl}`">
                <span>Préstamo</span>
                <template #icon="props">
                    <img :src="props.active ? iconLoan.active : iconLoan.inactive" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item name="order" :to="`/order${dynamicUrl}`" replace>
                <span>Pedido</span>
                <template #icon="props">
                    <img :src="props.active ? iconOrder.active : iconOrder.inactive" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import { Toast,Notify,Dialog } from 'vant';
import {mapActions, mapGetters,mapState} from 'vuex'
import getQueryVariable from '@/baseloan/service/getQueryVariable'
export default {
    name:'baseloan',
    data(){
        return{
            transitionName:'slide-left',
            active:'index',
            iconLoan:{
                active:require('@/baseloan/assets/icon-tab-01-active.png'),
                inactive:require('@/baseloan/assets/icon-tab-01.png'),
            },
            iconOrder:{
                active:require('@/baseloan/assets/icon-tab-02-active.png'),
                inactive:require('@/baseloan/assets/icon-tab-02.png'),
            },
            dynamicUrl:`?${window.location.hash.split('?')[1]}`,
        }
    },
    computed:{
        showTabbar(){
            return this.$route.path==='/index'|| this.$route.path==='/order'||this.$route.path==='/'
        }
    },
    watch:{
        '$route':{
            handler(newVal,oldVal){
                if(newVal.path==='/index'){
                    this.active='index';
                }
                if(newVal.path==='/order'){
                    this.active='order';
                }
                const toPath=newVal.path.split('/').length;
                const fromPath=oldVal.path.split('/').length;
                if(this.$route.path==='/index'|| this.$route.path==='/order'){
                    this.transitionName=''
                    return false
                }
                this.transitionName=toPath<fromPath?'slide-right':'slide-left';
            },
            deep:true,
        }
    },
    methods:{
        tabbarChange(active){

        },
    },
    mounted(){
        // a=SEZCN0U1NUE%3D&b=MTQzNzY2Nzk3NzU3MDAwNDk5NA%3D%3D&c=TXIuU3VtYmlsZQ%3D%3D&d=V2Vi
        // a: appid
        // b: userid
        // c: 性别+姓名
        // d: utmSource.申请订单是需要这个参数 解码后传过来
    }
}
</script>
<style rel="stylesheet" lang="scss">
    @import 'css/style';
    @import 'css/common';
</style>



// WEBPACK FOOTER //
// src/baseloan/App.vue